import React from 'react'
import Video from './Video.js'
import Img from 'gatsby-image'

const Media = ({ fluid, videoCheck, videoSrcURL, title, description }) => {
  return (
    <div className="mediaContainer">
      {/* Renderiza vídeo (mp4) ou imagem (gif) */}
      {videoCheck === 'mp4' ? (
        <Video
          videoSrcURL={videoSrcURL}
          className={`${title}Video`}
          description={description}
        />
      ) : videoCheck === 'gif' ? (
        <img src={videoSrcURL} alt={description} className={`${title}Gif`} />
      ) : (
        fluid && (
          <Img fluid={fluid} alt={description} className={`${title}Image`} />
        )
      )}
    </div>
  )
}

export default Media
